var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "workSpace" }, [
      _c("div", { staticClass: "photos" }, [
        _c("div", { staticClass: "viewHeader" }, [
          _c("div", { staticClass: "viewHeaderFlexBox" }, [
            _c("div", { staticClass: "headerBox" }, [
              _c("span", { staticClass: "header" }, [
                _vm._v(
                  "\n\t\t\t\t\t\t\t" +
                    _vm._s(_vm.$t("cloudPhotosDescription")) +
                    "\n\t\t\t\t\t\t"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "buttonBox" }, [
              _vm.importMode && _vm.toolbarMode
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSelectedPhotos,
                          expression: "hasSelectedPhotos",
                        },
                      ],
                      staticClass: "actionbutton desktopOnly",
                      on: { click: _vm.importPhotos },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("buttonImport")) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "topSection" }, [
          _vm.filterByDate
            ? _c("div", { staticClass: "selectGroup" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.fromYear,
                        expression: "fromYear",
                      },
                    ],
                    staticClass: "selectBox",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.fromYear = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeDate,
                      ],
                    },
                  },
                  [
                    _c("option", { attrs: { value: "-1" } }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("step2PeriodToggleYear")) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.arrYears, function (year) {
                      return _c(
                        "option",
                        { key: year, domProps: { value: year } },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" + _vm._s(year) + "\n\t\t\t\t\t\t"
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.filterByDate && _vm.fromYear > 0,
                  expression: "filterByDate && fromYear > 0",
                },
              ],
              staticClass: "selectGroup",
            },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.fromMonth,
                      expression: "fromMonth",
                    },
                  ],
                  staticClass: "selectBox",
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.fromMonth = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.changeDate,
                    ],
                  },
                },
                [
                  _c("option", { attrs: { value: "-1" } }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("step2PeriodToggleMonth")) +
                        "\n\t\t\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.arrMonths, function (month, i) {
                    return _c("option", { key: i, domProps: { value: i } }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" + _vm._s(month) + "\n\t\t\t\t\t\t"
                      ),
                    ])
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _vm.byCategory
            ? _c("div", { staticClass: "selectGroup" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.categoryFilter,
                        expression: "categoryFilter",
                      },
                    ],
                    staticClass: "selectBox",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.categoryFilter = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.changeCategory,
                      ],
                    },
                  },
                  _vm._l(_vm.arrCategories, function (category) {
                    return _c(
                      "option",
                      { key: category, domProps: { value: category } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(category.toLowerCase()) +
                            "\n\t\t\t\t\t\t"
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showLevelUpButton,
                  expression: "showLevelUpButton",
                },
              ],
              staticClass: "levelUpButton",
            },
            [
              _c(
                "button",
                { staticClass: "toolbutton", on: { click: _vm.levelUp } },
                [_c("i", { staticClass: "far fa-level-up" })]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "selectAllButton" }, [
            _c(
              "div",
              { class: _vm.selectAllButtonClass, on: { click: _vm.selectAll } },
              [
                _vm._v(
                  "\n\t\t\t\t\t\t" +
                    _vm._s(_vm.$t("buttonSelectAll")) +
                    "\n\t\t\t\t\t"
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.searchField
            ? _c("div", { staticClass: "search" }, [
                _c("input", {
                  staticStyle: { display: "none" },
                  attrs: {
                    id: "searchInput",
                    type: "text",
                    value: "",
                    placeholder: "#hashtag",
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.channelModel.folders &&
        _vm.folderCollection.length == 0 &&
        _vm.photoCollection.length == 0 &&
        _vm.folders.fetched
          ? _c("div", [
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("emptyFolder")) + "\n\t\t\t"),
            ])
          : _vm.channelModel.folders
          ? _c(
              "ul",
              { staticClass: "folderGrid" },
              _vm._l(_vm.folderCollection, function (folderModel) {
                return _c(
                  "li",
                  {
                    key: folderModel.id,
                    attrs: { folderModel: folderModel },
                    on: {
                      click: function ($event) {
                        return _vm.selectFolder(folderModel)
                      },
                    },
                  },
                  [
                    _vm._m(1, true),
                    _vm._v(" "),
                    _c("div", { staticClass: "folderTitle" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            folderModel.name.length > 30
                              ? folderModel.name.substring(0, 30) + "..."
                              : folderModel.name
                          ) +
                          "\n\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v(" "),
                    folderModel.count > 0
                      ? _c("div", { staticClass: "folderCount" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(folderModel.count) +
                              "\n\t\t\t\t\t"
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.photoCollection.length == 0 && _vm.photos.fetched
          ? _c("div", [
              _vm.channelModel.id == "app"
                ? _c("span", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("userPhotosEmpty")) +
                        "\n\t\t\t\t"
                    ),
                  ])
                : _vm._e(),
            ])
          : _c(
              "ul",
              { staticClass: "photoGrid" },
              _vm._l(_vm.photoCollection, function (cloudPhotoModel) {
                return _c("CloudPhotoView", {
                  key: cloudPhotoModel.id,
                  attrs: {
                    "cloud-photo-model": cloudPhotoModel,
                    "import-mode": _vm.importMode,
                    "is-selected": _vm.isSelected(cloudPhotoModel),
                  },
                  on: { unselect: _vm.unselectPhoto, select: _vm.selectPhoto },
                })
              }),
              1
            ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "workSpaceFooter" }, [
        _vm.loading
          ? _c("div", { staticClass: "loading" }, [
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("loading")) + "\n\t\t\t\t"),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "loadingBar" }),
            ])
          : _vm.photos.nextPage ||
            _vm.photos.nextOptions ||
            _vm.folders.nextPage ||
            _vm.folders.nextOptions
          ? _c(
              "button",
              {
                directives: [
                  {
                    name: "observe-visibility",
                    rawName: "v-observe-visibility",
                    value: _vm.scrollToBottom,
                    expression: "scrollToBottom",
                  },
                ],
                ref: "loadMoreButton",
                staticClass: "toolbutton",
                on: { click: _vm.loadMore },
              },
              [
                _vm._v(
                  "\n\t\t\t\t" + _vm._s(_vm.$t("buttonLoadMore")) + "\n\t\t\t"
                ),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.importMode && _vm.toolbarMode
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasSelectedPhotos,
                expression: "hasSelectedPhotos",
              },
            ],
            staticClass: "actionbutton floatButton mobileOnly",
            on: { click: _vm.importPhotos },
          },
          [_vm._v("\n\t\t" + _vm._s(_vm.$t("buttonImport")) + "\n\t")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "toolbutton searchButton", attrs: { id: "searchButton" } },
      [_c("i", { staticClass: "far fa-search" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "folderIcon" }, [
      _c("i", { staticClass: "fas fa-folder-open" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }